export const DeleteIcon = ({ className, onClick }) => {
  return (
    <svg
      className={className}
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <rect width="12" height="12" rx="6" fill="#A5A5A5" />
      <g clipPath="url(#clip0_80_18)">
        <path
          d="M8.25 3.75L3.75 8.25"
          stroke="white"
          strokeWidth="0.666667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.25 8.25L3.75 3.75"
          stroke="white"
          strokeWidth="0.666667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_80_18">
          <rect width="8" height="8" fill="white" transform="translate(2 2)" />
        </clipPath>
      </defs>
    </svg>
  );
};
